var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_609_114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 0C11.1937 0 0 11.1922 0 25C0 38.8078 11.1922 50 25 50C38.8078 50 50 38.8078 50 25C50 11.1922 38.8078 0 25 0ZM25 46.925C12.9375 46.925 3.125 37.0625 3.125 25C3.125 12.9375 12.9375 3.125 25 3.125C37.0625 3.125 46.875 12.9375 46.875 25C46.875 37.0625 37.0625 46.925 25 46.925ZM33.8391 16.1625C33.2297 15.5531 32.2406 15.5531 31.6297 16.1625L25.0016 22.7906L18.3734 16.1625C17.7641 15.5531 16.7734 15.5531 16.1625 16.1625C15.5516 16.7719 15.5531 17.7625 16.1625 18.3719L22.7906 25L16.1625 31.6281C15.5531 32.2375 15.5531 33.2281 16.1625 33.8375C16.7719 34.4469 17.7625 34.4469 18.3734 33.8375L25.0016 27.2094L31.6297 33.8375C32.2391 34.4469 33.2281 34.4469 33.8391 33.8375C34.45 33.2281 34.4484 32.2375 33.8391 31.6281L27.2109 25L33.8391 18.3719C34.45 17.7609 34.45 16.7719 33.8391 16.1625Z",
    fill: "#ACACAC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_609_114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.e361ccb0a28ec44686c6187a5046360d.svg";
export { ForwardRef as ReactComponent };